import React from 'react'
import Hero from '../Components/Hero'
import Footer from '../Components/Footer'
import WorkCard from '../Components/WorkCard'
import Education from '../Components/Education'


const Home = () => {
  return (
    <>
    <Hero/>
    <Education/>
    <WorkCard/>
    <Footer/>
    </>

  )
}

export default Home